import { BaseService } from '../../infra/base.service'
import type { ReportCatalogItem, ReportExportToken, ReportResponse } from './report-catalog'
import type { ReportCatalogRepository } from './report-catalog.repository'

export class ReportCatalogService extends BaseService<ReportCatalogItem> {
    constructor(private rep: ReportCatalogRepository) {
        super(rep)
    }

    async run(endpoint: string, params?: any): Promise<ReportResponse> {
        return await this.rep.run(endpoint, params)
    }

    async createExportToken(reportId?: string, params?: Record<string, any>, locale?: 'pt-BR' | 'en-US'): Promise<ReportExportToken> {
        return await this.rep.createExportToken(reportId, params, locale)
    }

    buildCsvUrl(reportId: string, params: Record<string, any>, exportToken: string): string {
        return this.rep.buildCsvUrl(reportId, params, exportToken)
    }
}
